// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"72":"thanks","189":"brief","314":"style","444":"designs","691":"colors"}[chunkId] || chunkId) + "." + {"72":"f0ebc0bd","189":"e3a3681e","314":"2bd1ed1f","402":"4d5d7b6e","444":"cc7100fe","520":"3f2edf42","691":"965362c3"}[chunkId] + ".css";
};